import { defineComponent as _defineComponent } from 'vue'
import { Ref, computed, ref, watch } from 'vue';
import { FullColorObject } from '@/composables/color';

type SliderDirection = 'horizontal' | 'vertical';


export default /*#__PURE__*/_defineComponent({
  __name: 'HueSlider',
  props: {
    colors: null,
    direction: { default: 'horizontal' }
  },
  emits: ["change"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'change', value: Partial<FullColorObject>): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { colors: FullColorObject, direction: SliderDirection };





const containerRef: Ref<HTMLDivElement | null> = ref(null);
const oldHue = ref(0);
const pullDirection: Ref<'right' | 'left' | ''> = ref('');

const directionClass = computed(() => {
    const classes: Record<SliderDirection, string> = {
        horizontal: 'c-hue--horizontal',
        vertical: 'c-hue--vertical'
    };

    return classes[props.direction];
});

const pointerTop = computed(() => {
    if (props.direction == 'horizontal') return 0;

    if (props.colors.hsl.h === 0 && pullDirection.value === 'right') return '100%';

    return -((props.colors.hsl.h * 100) / 360) + 100 + '%';
});

const pointerLeft = computed(() => {
    if (props.direction == 'vertical') return 0;

    if (props.colors.hsl.h === 0 && pullDirection.value === 'right') return '100%';

    return (props.colors.hsl.h * 100) / 360 + '%';
});

watch(
    () => props.colors.hsv,
    () => {
        const { h } = props.colors.hsv;
        if (h !== 0 && h - oldHue.value > 0) pullDirection.value = 'right';
        if (h !== 0 && h - oldHue.value < 0) pullDirection.value = 'left';
        oldHue.value = h;
    },
    { deep: true }
);

const handleChange = (e: MouseEvent | TouchEvent) => {
    e.preventDefault();

    const container = containerRef.value;

    // for some edge cases, container may not exist
    if (!container) return;

    const containerWidth = container.clientWidth;
    const containerHeight = container.clientHeight;

    const xOffset = container.getBoundingClientRect().left + window.scrollX;
    const yOffset = container.getBoundingClientRect().top + window.scrollY;
    const pageX = (e as MouseEvent).pageX || ((e as TouchEvent).touches ? (e as TouchEvent).touches[0].pageX : 0);
    const pageY = (e as MouseEvent).pageY || ((e as TouchEvent).touches ? (e as TouchEvent).touches[0].pageY : 0);
    const left = pageX - xOffset;
    const top = pageY - yOffset;

    let hue;
    let percent;

    if (props.direction === 'vertical') {
        if (top < 0) {
            hue = 360;
        } else if (top > containerHeight) {
            hue = 0;
        } else {
            percent = -((top * 100) / containerHeight) + 100;
            hue = (360 * percent) / 100;
        }
    } else {
        if (left < 0) {
            hue = 0;
        } else if (left > containerWidth) {
            hue = 360;
        } else {
            percent = (left * 100) / containerWidth;
            hue = (360 * percent) / 100;
        }
    }

    if (props.colors.hsl.h !== hue) {
        emit('change', {
            hsl: {
                ...props.colors.hsl,
                h: hue
            }
        });
    }
};

const handleMouseUp = () => {
    unbindEventListeners();
};

const handleMouseDown = () => {
    window.addEventListener('mousemove', handleChange);
    window.addEventListener('mouseup', handleMouseUp);
};

const unbindEventListeners = () => {
    window.removeEventListener('mousemove', handleChange);
    window.removeEventListener('mouseup', handleMouseUp);
};

return { __sfc: true,props, emit, containerRef, oldHue, pullDirection, directionClass, pointerTop, pointerLeft, handleChange, handleMouseUp, handleMouseDown, unbindEventListeners }
}

})